import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    tarea: {
        titulo: null,
        fecha: null,
        hora: null,
        estado: 'pendiente'
    },
    cita: {
        titulo: null,
        lugar: null,
        inicio_date: null,
        inicio_time: null,
        fin_date:null,
        fin_time: null,
        description: null,
        estado: 'pendiente'
    },
    nota: {
        description: null,
        estado: 'pendiente'
    }
};
const mutations = {
    updateField,
};
const getters = {
    getField
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
